import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip } from "@mui/material";
import { MuiMarkdown_V2 } from "../MuiMarkdown/MuiMarkdown_V2";
export const ToggleCardDescription = ({ description, descriptionLines }) => (_jsx(Box, Object.assign({ sx: {
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: descriptionLines,
        overflow: "hidden",
        textOverflow: "ellipsis",
    } }, { children: _jsx(Tooltip, Object.assign({ placement: "bottom", title: description }, { children: _jsx(MuiMarkdown_V2, Object.assign({ pVariant: "body2" }, { children: description })) })) })));
